<template>
	<div class="troubleshooting-loc">
		<TroubleshootingMenu tab="location"></TroubleshootingMenu>
		<div class="troubleshooting-query">

			<label>extCompRef</label>
			<input v-model="extCompRef" name="extCompRef" v-validate.initial="extCompRef" v-on:keyup.enter="search" type="text" data-vv-rules="required|numeric" data-vv-name="extCompRef" class="text-input bg-white">
			<p class="text-danger" v-if="errors.has('extCompRef')">{{ errors.first('extCompRef') }}</p>
			<br>
			<label>Location/Node ID</label>
			<input v-model="storeId" name="storeId" v-validate.initial="storeId" v-on:keyup.enter="search" type="text" data-vv-rules="required|numeric" data-vv-name="Location/Node Id" class="text-input bg-white">
			<p class="text-danger" v-if="errors.has('Location/Node Id')">{{ errors.first('Location/Node Id') }}</p>
			<br>
			<button :disabled="searching" v-on:click="search" class="button raised">Search</button>

		</div>
		<div v-if="searching">
			<loading-bar></loading-bar>
			<p class="text-center">{{waitmsg}}</p>
		</div>
		<br>
		<div v-if="res">
			Location/Node was found in HS Hierarchy.xml. Users for this locations should be synced.
			<table class="table table-striped table-bordered">
				<thead>
					<tr>
						<th>Location/Node ID</th>
						<th>Location/Node</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{resid}}</td>
						<td>{{resdesc}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div  class="text-danger">{{err}}</div>
	</div>
</template>
<script>
import TroubleshootingMenu from './TroubleshootingMenu'

export default{
	components: {
		TroubleshootingMenu
	},
	data () {
		return {
			extCompRef: '',
			storeId: '',
			waitmsg: 'This may take a moment.'
		}
	},
	computed: {
		res () {
			console.log('this.$store.state.hierarchy', this.$store.state.hierarchy)
			return this.$store.state.hierarchy.store
		},
		resid () {
			return this.res.id
		},
		resdesc () {
			return this.res.description
		},
		err () {
			return this.$store.state.hierarchy.err
		}
	},
	methods: {
		search () {
			this.$validator.validateAll()

			if (!this.errors.any()) {
				this.$store.dispatch('getHierarchyStore', { extCompRef: this.extCompRef, storeId: this.storeId })
			}
		}
	},
	beforeMount () {
		if (this.$route.params.extCompRef && this.$route.params.storeId) {
			this.extCompRef = this.$route.params.extCompRef
			this.storeId = this.$route.params.storeId
			this.search()
		}
	},
	beforeDestroy () {
		this.$store.dispatch('clearHierarchyStore')
	}
}
</script>
<style>
.troubleshooting-loc label{
	display:  inline-block;
	width:  120px;
}
</style>



// WEBPACK FOOTER //
// TroubleshootingLoc.vue?87dc18d0